/**
 * Pitch Bar (clean)
 *
 * a clean directive to create the pitch bar with reusability in mind
 *
 * @author Vinny DeFrancesco
 */

import template from './pitchBar.html';

function pitchBarClean() {
  return {
    restrict: 'E',
    scope: {
      pitch: '=',
      type: '@'
    },
    template,
    controller: 'PitchBarController'
  };
}

function PitchBarController($scope, $translate, toastWrapperService) {
  $scope.pitchVM = angular.copy($scope.pitch);
  $scope.pitch.newStatus = $scope.pitch.currentStatus;
  $scope.status = { selected: false };
  $scope.availableStatuses = $scope.pitch.pitchStatuses;

  $scope.updateStatus = () => {
    $scope.pitch.save()
      .then((response) => {
        $scope.pitch = response;
        $scope.pitch.newStatus = $scope.pitch.currentStatus;
        $scope.status.selected = false;

        toastWrapperService.createToast($translate.instant('PITCH_STATUS_UPDATED'), 'success');
      }, () => {
        toastWrapperService.createToast($translate.instant('ERROR_UPDATING_PITCH_STATUS'), 'danger');
      });
  };

  $scope.appendLastNote = () => {
    $scope.pitch.appendLastNote();
  };
}

const arrCtrl = [
  '$scope',
  '$translate',
  'toastWrapperService',
  PitchBarController
];

export default function (ngModule) {
  ngModule.directive('pitchBar', [
    pitchBarClean
  ]);

  ngModule.controller('PitchBarController', arrCtrl);
}
